import { useNavigate } from 'react-router';
import { IconChevronLeft } from '@tabler/icons-react';
import { ClientsTable } from '../ClientsTable';
import { useFamily } from '../hooks/useFamily';

export function FamilyClientsTable({ id }: { id: string }) {
  const { family } = useFamily(id);
  const navigate = useNavigate();
  const title = [family?.name, 'Family'].filter(Boolean).join(' ');

  const editButton = {
    label: 'Edit family',
    variant: 'default' as const,
    onClick: () => {
      if (!family) return;
      navigate(`/clients/families/${family.id}/edit`);
    },
  };

  return (
    <ClientsTable
      title={title}
      titleIcon={<IconChevronLeft />}
      onTitleClick={() => {
        navigate(`/clients/families`);
      }}
      filters={{ familyId: id }}
      showViewModes={false}
      primaryButton={editButton}
    />
  );
}
